import { DOCUMENT } from "@angular/common";

import { Inject, Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class GoogleTagService {
  private readonly renderer: Renderer2;

  constructor(
    private readonly rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadGoogleTag(): void {
    const gTagManagerScript = this.renderer.createElement(
      "script",
    ) as HTMLScriptElement;
    // register google tag manager
    gTagManagerScript.async = true;
    gTagManagerScript.src = `https://www.googletagmanager.com/gtag/js?id=${environment.GA_MEASUREMENT_ID}"`;
    this.renderer.appendChild(this.document.head, gTagManagerScript);

    // register google analytics
    const gaScript = this.renderer.createElement("script") as HTMLScriptElement;
    gaScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){ dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', '${environment.GA_MEASUREMENT_ID}');
    `;

    this.renderer.appendChild(this.document.head, gaScript);
  }
}
